import { currencyFormatterNull } from "../../../components/Charts";
import { Series } from "../../../components/Charts/MultipleLine/types";
import { InvestmentsHistoryResponse } from "../../../services";
import { InvestmentsHistoryPoint } from "../../../services/investments/types";
import { historyXLabelsOf } from "../historyLabels";

export interface InvestmentsGrowth {
  xLabels: string[];
  series: Series[];
  points: InvestmentsHistoryPoint[];
}

export const buildInvestmentsGrowth = (
  history: Pick<InvestmentsHistoryResponse, "data"> &
    Partial<Pick<InvestmentsHistoryResponse, "range">>,
): InvestmentsGrowth => {
  const xLabels = historyXLabelsOf(history.data, history.range?.sampling);
  const valueData = history.data.map((point) => point.brokerValue);
  const investedData = history.data.map((point) => point.invested);

  const series: Series[] = [
    {
      id: "value",
      data: valueData,
      label: "Value",
      area: true,
      showMark: false,
      color: "var(--color-success)",
      valueFormatter: currencyFormatterNull,
    },
    {
      id: "invested",
      data: investedData,
      label: "Invested",
      area: false,
      dashed: true,
      showMark: false,
      color: "var(--color-text-secondary)",
      valueFormatter: currencyFormatterNull,
    },
  ];

  return {
    xLabels,
    series,
    points: history.data,
  };
};
